var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460,351.8c-0.8-0.6-87.8-62.9-111.4-58.8c-11.4,2-17.8,9.7-30.9,25.2c-2.1,2.5-7.1,8.5-11,12.7c-8.2-2.7-16.2-5.9-24-9.8 c-40-19.5-72.4-51.8-91.9-91.9c-3.8-7.8-7.1-15.8-9.8-24c4.3-3.9,10.3-9,12.8-11.1c15.4-12.9,23.2-19.4,25.2-30.8 c4.1-23.5-58.2-110.6-58.8-111.4c-5.7-8.2-14.8-13.3-24.8-14C110.1,38,38,131.5,38,147.3c0,0.9,1.3,94,116.1,210.7 c116.6,114.6,209.7,116,210.6,116c15.8,0,109.3-72.1,109.3-97.4C473.3,366.7,468.1,357.6,460,351.8z M363.1,444.8 c-12.7-1-90.8-11.4-188.5-107.3C78.2,239.4,68.2,161.1,67.2,148.9c19-29.9,42.1-57.1,68.4-80.8c0.6,0.6,1.4,1.5,2.3,2.6 c20.2,27.6,37.6,57.1,51.9,88.1c-4.7,4.7-9.6,9.1-14.8,13.2c-8,6.1-15.4,13-22,20.7l-3.5,4.9l1,6c3.1,13.3,7.8,26.2,14,38.4 c22.4,45.9,59.4,83,105.3,105.3c12.2,6.2,25.1,11,38.4,14l6,1l4.9-3.5c7.7-6.6,14.6-14,20.8-22.1c4.5-5.4,10.6-12.7,12.9-14.7 c31.1,14.3,60.7,31.8,88.3,52c1.2,1,2,1.8,2.6,2.3C420.2,402.8,393,425.8,363.1,444.8L363.1,444.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.d1e45ece9f8e45fd55eb3ecd451f7d7d.svg";
export { ForwardRef as ReactComponent };